import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import DashboardAnalyticsModel from "../../models/dashboard-analytics";

export default class DashboardAnalyticsRepository extends BaseRepository {
  static modelClass = DashboardAnalyticsModel;
  modelName = "dashboard-analytics";
}
